import "./Footer.css";
import BookIcon from "@mui/icons-material/Book";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import QuizIcon from "@mui/icons-material/Quiz";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <BookIcon /> Subjects
        </div>
        <div className="footer-section">
          <CreditCardIcon /> Flashcards
        </div>
        <div className="footer-section">
          <SportsEsportsIcon /> Games
        </div>
        <div className="footer-section">
          <QuizIcon /> Quizzes
        </div>
      </div>
      <p className="footer-copy">© 2025 Mukuwa A. Baffoe. All rights reserved.</p>
      <div className="footer-decor">
        {/* Love for the Hangeul ABCs */}
        <span>한글</span> <span>가나다에</span> <span>대한</span> <span>사랑</span>
      </div>
    </footer>
  );
};

export default Footer;
